import './designers';

export default (element, { layout }) => {
  const init = () => {
    const isMobile = layout.isBelowBreakpoint('md');
    // rootMargin is based on the scroll margin top of the nav items
    // and the height of the sticky header, which is 192px on mobile and 240px on desktop (scroll-mt-[12rem] md:scroll-mt-[15rem]).
    // This ensures that the nav items are highlighted when the section is scrolled into view.
    // The -60% is to ensure that the section is fully in view before the nav item is highlighted.
    const rootMargin = isMobile ? '-192px 0px -55% 0px' : '-240px 0px -60% 0px';
    configureIntersectionObserver({ rootMargin });
  };

  const configureIntersectionObserver = ({ rootMargin }) => {
    const allNavItems = document.querySelectorAll('[data-designer-nav-group]');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const designerGroup = entry.target.getAttribute(
            'data-designer-group',
          );
          const activeNavItem = document.querySelector(
            `[data-designer-nav-group="${designerGroup}"]`,
          );
          if (!activeNavItem) return;
          activeNavItem.classList.add('!underline');
          allNavItems.forEach((item) => {
            if (item !== activeNavItem) {
              item.classList.remove('!underline');
            }
          });
        });
      },
      { threshold: 1, rootMargin },
    );

    const wordSections = element.querySelectorAll('[data-designer-group]');
    wordSections.forEach((section) => observer.observe(section));
  };

  init();
};
